import { render, staticRenderFns } from "./WizardContentHorizontalContainer.vue?vue&type=template&id=b557a494&scoped=true&"
import script from "./WizardContentHorizontalContainer.vue?vue&type=script&lang=ts&"
export * from "./WizardContentHorizontalContainer.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentHorizontalContainer.vue?vue&type=style&index=0&id=b557a494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b557a494",
  null
  
)

export default component.exports